import { useIntl } from "react-intl";
import { MembershipIcon } from "../../../assets/SVGs/SVGs";
import SubInfo from "./SubInfo";

type Props = { data: any };

const SaleCardMembership = ({ data }: Props) => {
  const getExpiryDurationInDays = (duration: string) => {
    let days = 0;
    switch (duration) {
      case "one_month":
        days = 30;
        break;
      case "three_months":
        days = 90;
        break;
      case "six_months":
        days = 180;
        break;
      case "one_year":
        days = 365;
        break;
    }
    return days;
  };
  const intl = useIntl();
  return (
    <div
      style={{ border: "1px solid #EEF0FF" }}
      className="flex flex-col items-center justify-between w-full gap-2 px-3 py-2 rounded-lg"
    >
      <div className="flex items-center justify-start w-full gap-2 text-color-primary">
        <span>{MembershipIcon}</span> <span>{data?.itemable?.name}</span>
      </div>
      <div className="flex items-center justify-between w-full">
        <div className="flex items-center gap-4">
          <span className="text-[#75757E] flex items-center gap-2">
            <span>
              {intl.formatMessage({
                id: "services",
              })}
            </span>
            <span>{data?.itemable?.pricing_option?.length}</span>
          </span>
          <span className="text-[#75757E] flex items-center gap-2" dir="ltr">
            <span>
              {intl.formatMessage({
                id: "sessions",
              })}
            </span>
            <span>{data?.itemable?.sessions}</span>
          </span>
          <SubInfo
            value={getExpiryDurationInDays(data?.itemable?.expire_duration)}
            label={intl.formatMessage({
              id: "day",
            })}
          />
        </div>
        <SubInfo
          value={data?.itemable?.price}
          label={intl.formatMessage({
            id: "SARshort",
          })}
        />
      </div>
    </div>
  );
};

export default SaleCardMembership;
